import Navbar from '../navigation/Navbar';
import Footer from '../../components/app/Footer';
import AboutHome from './AboutHome';


function AboutUsPage() {

    return (
        <>
        <Navbar selected='Help'/>
        <AboutHome></AboutHome>
        <Footer></Footer>
        </>
    );
}

export default AboutUsPage;